import { withValueVersion } from "../../WSUtils/withValueVersion";
import { BackendResponse } from "../BackendResponse";
import { getNextApiUrl } from "../getNextApiUrl";

export interface GetDocumentDownloadUrlResponse extends BackendResponse {
  url: string;
}

export interface GetDocumentDownloadUrlParameters {
  idConcern: number;
  idDocument: number;
  idCandidate: number;
  downloadDocumentToken: string;
}

export type getDocumentDownloadUrl = (
  args: GetDocumentDownloadUrlParameters
) => GetDocumentDownloadUrlResponse;

export const getDocumentDownloadUrl: getDocumentDownloadUrl = withValueVersion(
  (args) => {
    return {
      url:
        getNextApiUrl("/cvp/CvpDownloadDocument") +
        `?idCandidate=${args.idCandidate}` +
        `&idDocument=${args.idDocument}` +
        `&downloadDocumentToken=${args.downloadDocumentToken}`,

      ok: true,
      elapsedMilliseconds: 0,
      statusCode: 1200,
    };
  },
  false
);
